import axios from 'axios' // eslint-disable-line no-restricted-imports

export const nextApiRoutesClient = axios.create()
